module.exports = __webpack_public_path__ + "static/media/banner1.e9e85102.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/aerolift/images/banner1.jpg
// module id = 533
// module chunks = 0